export default {
  years: 'an | ans',
  months: 'mois',
  days: 'jour | jours',
  hours: 'heure | heures',
  minutes: 'minute | minutes',
  seconds: 'seconde | secondes'
}
